import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SPECIAL_OFFER_ROUTES } from 'src/app/core/constants/routes-constants';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { AuthorizeService } from 'src/app/core/services/authorize.service';
import { SPECIAL_OFFER_CLIENT_STATUS, SPECIAL_OFFER_STATUS } from 'src/app/extensions/constants/commonConstants';
import { GlobalService } from '../../../../extensions/services/global.service';

@Component({
  selector: 'special-offer-card-view',
  standalone: false,
  templateUrl: './special-offer-card-view.component.html',
  styleUrl: './special-offer-card-view.component.scss',
})
export class SpecialOfferCardViewComponent {
  @Input() specialOffers: app.models.FilteredSpecialOfferClientModel[];
  @Input() props: app.models.DynamicPropsDictionary;
  path: string;
  accesToken: string;
  appId: string;
  SPECIAL_OFFER_STATUS = SPECIAL_OFFER_CLIENT_STATUS;

  constructor(
    private _router: Router,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData,
    private _authorizeService: AuthorizeService,
    private _globalService: GlobalService
  ) {
    this.path = _envConfig.FILE_MANAGER_API_URL;
    this.accesToken = this._authorizeService.accessToken;
    this.appId = this._globalService.appId;
  }

  navigateToDetailHandler(specialOffer: app.models.FilteredSpecialOfferClientModel) {
    if (specialOffer.status === SPECIAL_OFFER_STATUS.UPCOMING) {
      return;
    }
    this._router.navigate([
      SPECIAL_OFFER_ROUTES.SPECIAL_OFFERS,
      SPECIAL_OFFER_ROUTES.PREVIEW,
      specialOffer.specialOfferId,
    ]);
  }
}
